"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoUpload = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var userInfo_1 = require("../../model/userInfo");
var service_1 = require("../../../library/base/service");
var PhotoUpload = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PhotoUpload, _super);
    function PhotoUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '用户头像上传功能';
        _this.code = '101084';
        _this.desc = '用户头像上传功能';
        _this.requestParams = new userInfo_1.PhotoUploadRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PhotoUpload;
}(service_1.BaseService));
exports.PhotoUpload = PhotoUpload;
//# sourceMappingURL=photoUpload.js.map